<template>
  <div class="panel-body main-content row">
    <div class="contentLeft">
      <div class="top_content">
        <div id="service">
          <div class="toptitle">
            <h1>携帯電話会社が定めるSMS利用規則</h1>
          </div>
          <div class="section">
            <ol class="campaign">
              <li>■KDDI株式会社が定める利用規則<br>
                <ol>
                  <li>本サービスを利用する場合、事前に次の同意を得ること。<br />au携帯電話の契約者（以下、「au加入者」という。）にSMS(Cメール)を配信（以下「本件配信」という。）するにあたり、au加入者より、事前に本件配信の許諾（以下「本件許諾」という。）を得ること。<br />
                    なお、本件許諾は、少なくとも、au加入者が保有するau携帯電話の契約者回線におけるSMS(Cメール)安心ブロック機能の設定の如何にかかわらず、URLや電話番号が記載された内容が含まれる本件配信がなされることについての同意、および本件配信に係るKDDIの免責を含んだものでなければならず、その具体的な内容、取得方法等について、事前にKDDIからの同意を得なくてはならない。（※1）<br />
                    また、KDDIから要請がある場合は、本件許諾に係るログ情報またはその他の情報で本件許諾の取得を証明する資料を、遅滞なく提供すること。
                  </li>
                  <li>本サービスを用いて、au加入者が迷惑と感じるSMS(Cメール)(以下「迷惑メール（※2）」という。)を送信しないこと。<br />
                    なお、迷惑メールを送信している事実が疑われる場合、本サービスの提供を停止することもあります。
                  </li>
                </ol>
                <br /></li>
              <li>（※1）提出する情報<br />
                <ul class="info">
                  <li>・ 配信予定メッセージの内容 </li>
                  <li>・ 許諾の取得方法</li>
                </ul>
              </li>
              <li>（※2）迷惑メールの定義<br />
                <ul class="mail">
                  <li>迷惑メールには次の内容を含むが、これらに限定されないものとする。</li>
                  <li>1）公序良俗に反する内容を含むもの</li>
                  <li>2）反社会勢力に属するまたはその関連が疑われる者が運営する事業に関するもの</li>
                  <li>3）青少年に有害なもの（成人向けサービス、出会い系要素を含むもの）</li>
                  <li>4）社会通念上の倫理に反するもの</li>
                  <li>5）法規、条例に違反するもの（発信国、受信国それぞれの法規制に違反しないこと）</li>
                  <li>6）第三者の知的財産権を侵害し又はそのおそれがあるもの</li>
                  <li>7）詐欺、ねずみ講、マルチ商法等の疑いがあるもの</li>
                  <li>8）本件許諾の内容を逸脱した内容（例：無差別的な広告等）を含むもの</li>
                  <li>9）上記の他、au加入者又は第三者からの申告に基づく調査の結果、KDDIが不適切と判断したもの</li>
                </ul>
                <br /></li>
              <li>■株式会社NTTドコモが定める利用規則<br />
                <ol>
                  <li>本サービスをご利用する場合、事前に携帯契約者にSMS送信の承諾を得ること</li>
                  <li>SMS送信の停止を依頼した携帯契約者への送信は停止すること</li>
                  <li>事業譲渡、分割、合併等により本サービスをご利用する主体が変更される場合、定期的にSMS送信をすることを承諾していた携帯契約者にその旨を通知すること</li>
                  <li>本サービスのご利用を終了するときは、あらかじめ、定期的にＳＭＳ送信をすることを承諾していた携帯契約者にその旨を通知すること</li>
                </ol>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'account_index',
  components:{
  }
}
</script>